export const NAME = 'smtp' as const;